module.exports = __webpack_public_path__ + "static/media/fiat-go-drive.f0abf2c5.png";